import { createFileRoute } from '@tanstack/react-router'

import { AuthResendConfirmationPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/resend-confirmation')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthResendConfirmationRoute
})

function TenantAuthResendConfirmationRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthResendConfirmationPage
      digitalProductId={tenant?.digitalProductId ?? undefined}
    />
  )
}
